import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import Notification from "../Common/Notification";

import { setCookie } from "../utility/Cookie";

const RegForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [compleatInputs, setCompleatInputs] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
  });

  const handelChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
    if (errorMsg) {
      let { errors } = validateFrom();
      setErrorMsg(errors);
    }
  };

  const validation = {
    first_name: (val) => val.length > 0,
    last_name: (val) => val.length > 0,
    email: (val) => val && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
    password: (val) =>
      val &&
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#/|])[A-Za-z\d@$!%*?&#/|]{8,}$/.test(
        val
      ),
    confirm_password: (val) => val === userData.password,
  };

  const validateFrom = () => {
    let errors = {};
    let valid = false;

    for (let key of Object.keys(userData)) {
      if (validation[key] !== "") {
        errors[key] = !validation[key](userData[key]);
        valid |= errors[key];
      }
    }
    return {
      errors: errors,
      valid: !valid,
    };
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    setIsPending(true);
    let { errors, valid } = validateFrom();

    const data = {
      first_name: userData.first_name,
      last_name: userData.last_name,
      email: userData.email,
      password: userData.password,
    };

    if (!valid) {
      setErrorMsg(errors);
      setCompleatInputs(!valid);
      setIsPending(false);
    } else {
      fetch(`${process.env.REACT_APP_BASE_URL}/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => {
          setIsPending(false);
          if (data.status === "success") {
            const user = {
              first_name: userData.first_name,
              last_name: userData.last_name,
              email: userData.email,
            };
            setErrorMsg(false);
            setCookie("_r_", data.msg.user.role, 1);
            setCookie("_g_", JSON.stringify(user), 1);
            setCookie("_t_", data.msg.token, 1);
            // localStorage.setItem("token", data.msg.token);

            // localStorage.setItem("_g_user", JSON.stringify(user));
            window.location.href = "/";
            setIsPending(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setIsPending(false);
        });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setCompleatInputs(false);
    }, 2000);
  }, [compleatInputs]);

  return (
    <>
      {compleatInputs && <Notification text="Please fill all the fields" />}
      <div className="contactForm">
        <div className="row">
          <div className="col-12">
            <Link to="/">
              <img src="BlueLogo.svg" alt="logo" />
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h1>
              Sign Up To <span>TEXTGENUSS</span>
            </h1>

            <form onSubmit={handelSubmit}>
              <div className="row mb-3">
                <div className="col-6">
                  <label className="form-label">First name</label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={handelChange}
                    name="first_name"
                  />
                  {errorMsg?.first_name && (
                    <div className="error">
                      <span>First name is required</span>
                    </div>
                  )}
                </div>
                <div className="col-6">
                  <label className="form-label">Last name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="last_name"
                    onChange={handelChange}
                  />
                  {errorMsg?.last_name && (
                    <div className="error">
                      <span>Last name is required</span>
                    </div>
                  )}
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  onChange={handelChange}
                />
                {errorMsg?.email && (
                  <div className="error">
                    <span>Email is required</span>
                  </div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <div className="form-control-input d-flex align-items-center">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    onChange={handelChange}
                    name="password"
                  />
                  <div
                    role="button"
                    aria-label="show-password"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <i className="fas fa-eye"></i>
                    ) : (
                      <i className="fas fa-eye-slash"></i>
                    )}
                  </div>
                </div>
                {errorMsg?.password && (
                  <div className="error">
                    <span>
                      Password must be at least 8 characters long and contain at
                      least one number, one uppercase and one lowercase letter
                      and one special character
                    </span>
                  </div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">Confirm Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  onChange={handelChange}
                  name="confirm_password"
                />
                {errorMsg?.confirm_password && (
                  <div className="error">
                    <span>Password and confirm password must be same</span>
                  </div>
                )}
              </div>

              <button
                className="btn contBut"
                type="submit"
                disabled={isPending}
              >
                {isPending ? "Loading..." : "Sign Up"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegForm;
